import React from "react";
import {
    HomeOutlined,
    UserOutlined,
    ProfileOutlined,
    CloudOutlined,
    ThunderboltOutlined,
    ReadOutlined,
    PlusCircleOutlined,
    AlertOutlined,
    LineChartOutlined,
    BookOutlined,
    RobotOutlined,
    CalendarOutlined
} from '@ant-design/icons';

const user_routes_ppr = [
    {
        key: 1,
        icon: <HomeOutlined />,
        name: 'Главная',
        path: '/main',
    },

    {
        key: 10,
        icon: <PlusCircleOutlined />,
        name: 'Создать Наряд-задание',
        path: '/create-task-new',
    },
    {
        key: 3,
        icon: <ThunderboltOutlined />,
        name: 'Наряд-допуск (электро)',
        path: '/electro-journal',
    },
    {
        key: 4,
        icon: <AlertOutlined />,
        name: 'Наряд-допуск (не электро)',
        path: '/non-electro-journal',
    },


    {
        key: 7,
        icon: <ReadOutlined />,
        name: 'Распоряжение',
        path: '/operation',
    },
    {
        key: 8,
        icon: <ReadOutlined />,
        name: 'Работа в порядке текущей эксплуатации',
        path: '/current-operation',
    },
    // {
    //     key: 6,
    //     icon: <CloudOutlined />,
    //     name: 'Журнал погоды',
    //     path: '/weather-journal',
    // },
    {
        key: 5,
        icon: <ProfileOutlined />,
        name: 'Журнал видов работ',
        path: '/ProcessJournal',
    },
    {
        key: 2,
        icon: <UserOutlined />,
        name: 'Журнал пользователей',
        path: '/user-journal',
    },
    {
        key: 18,
        icon: <BookOutlined />,
        name: 'Журнал инструкции',
        path: '/instructions',
    },
    {
        key: 11,
        icon: <LineChartOutlined />,
        name: 'Отчёт',
        path: '/report',
    },
    {
        key: 17,
        icon: <RobotOutlined />,
        name: 'Smax',
        path: '/smax',
    },
    {
        key: 20,
        icon: < CalendarOutlined twoToneColor="#eb2f96" />,
        name: 'ППР',
        path: '/ppr_table',
    },
];

export default user_routes_ppr
